import styles from './index.module.scss'
import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { BatchImagesContext } from '../BatchImagesContext.js'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import API from "@api/api";
import PSAIModal from "@PSAIComponents/PSAIModal";
import Utils from '@utils/utils';
import UploadBox from '../components/UploadBox/index.jsx'
import { Progress, message } from "antd"
import { UPLOAD_SOURCE, BATCH_IMAGES_TYPE } from "@utils/CONST"
import { AppContext } from '@utils/AppContext';
import TableWrap from './table.jsx'


const ConfigPage = () => {
    const { fileList, setFileList, setUploadImgToSkuId, uploadImgToSkuId } = useContext(BatchImagesContext)
    const { globalUser } = useContext(AppContext)
    const navigate = useNavigate()
    const { isProCenter } = useLocation().state || {}
    const location = useLocation()
    const [uploading, setUploading] = useState(false)
    const [uploadFileList, setUploadFileList] = useState([])
    const [dataSource, setDataSource] = useState([])
    const [errorOpen, setErrorOpen] = useState(false)
    const [errorList, setErrorList] = useState([])
    const [successList, setSuccessList] = useState([])
    const [allUploadFail, setAllUploadFail] = useState(false)
    const isMounted = useRef(true)
    const { projectId } = useParams()
    const [projectType, setProjectType] = useState("")
    const [projectName, setProjectName] = useState("")
    const [total, setTotal] = useState(0) // 用户选完素材后生成图总数
    const [skuId, setSkuId] = useState("")
    const [taskId, setTaskId] = useState("")
    const [projectSerial, setProjectSerial] = useState("")
    const uploadMaxNumber = useRef(10)

    // 再次编辑取参数
    const isEdit = useMemo(() => {
        const params = new URLSearchParams(location.search);
        const skuId = params.get('skuId');
        const taskId = params.get('taskId');

        if (skuId) setSkuId(skuId)
        if (taskId) setTaskId(taskId)
        if (skuId && taskId) return true
    }, [location.search])

    const concurrentSku = useRef(50)
    useEffect(() => {
        concurrentSku.current = globalUser?.membership?.concurrentSku || 50
    }, [globalUser])


    // sku列表
    const listSkuByProject = async (editCurrentData) => {
        if (editCurrentData?.length === 0 || !editCurrentData) {
            try {
                const res = await API.listSkuByProject({
                    projectId,
                    skuId,
                    taskId,
                })
                if (res?.code == -5003) navigate("/home/product/batchImages")
                if (res.code === -5067) { navigate('/home/product/batchImages'); return }
                if (res.code !== 0) throw new Error(res.message)
                const skuList = res?.data?.skuDetailList || [];
                setProjectType(res?.data?.projectType);
                setProjectName(res?.data?.projectName);
                setProjectSerial(res?.data?.projectSerial);
                setTotal(res?.data?.total || 0)
                setDataSource([...skuList])
            } catch (err) {
                message.error(err.message || "请求失败");
            }
        } else {
            setDataSource([...editCurrentData])
        }
    };

    useEffect(() => {
        listSkuByProject()
        isMounted.current = true
        return () => {
            isMounted.current = false
        }
    }, [])

    // 遍历获取AI试衣列表中的服装类型
    const checkedSkuRef = useRef([]);
    useEffect(() => {
        if (isEdit) return;
        if (projectType !== BATCH_IMAGES_TYPE.TRYON_BATCH || !dataSource || dataSource.length === 0 || uploading) return;

        const unprocessed = dataSource.filter(item => {
            const mainCloth = item?.inputImages?.find(img => img.mainImage === true);
            return (
                mainCloth &&
                (mainCloth.clothType == null || mainCloth.clothType === '') &&
                item.skuId && !checkedSkuRef.current.includes(item.skuId)
            );
        });

        if (unprocessed.length === 0) return;

        const getClothType = async () => {
            for (const item of unprocessed) {
                if (!isMounted.current) break;
                checkedSkuRef.current.push(item.skuId);
                console.log('checkedSkuRef.current', checkedSkuRef.current)

                const mainCloth = item.inputImages.find(img => img.mainImage === true);
                if (!mainCloth?.url) {
                    checkedSkuRef.current = checkedSkuRef.current.filter(id => id !== item.skuId);
                    continue;
                }

                try {
                    const clothRes = await API.getClothType({ imageUrl: mainCloth.url });
                    if (clothRes?.code === 0) {
                        const newType = clothRes.data;
                        mainCloth.clothType = newType;

                        setDataSource(prev =>
                            prev.map(it => {
                                if (it.skuId !== item.skuId) return it;
                                const newImages = it.inputImages.map(img =>
                                    img.mainImage ? { ...img, clothType: newType } : img
                                );
                                return { ...it, inputImages: newImages, projectId };
                            })
                        );

                        checkedSkuRef.current = checkedSkuRef.current.filter(id => id !== item.skuId);
                    }
                } catch (err) {
                    console.error('getClothType error', err);
                }
            }
        };
        getClothType();
    }, [projectType, dataSource, uploading, isEdit]);

    // 遍历获取同款换色列表中的服装类型
    const checkedSkuRef2 = useRef([]);
    useEffect(() => {
        if (
            projectType !== BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
            !dataSource ||
            dataSource.length === 0 ||
            uploading
        ) return;

        const unprocessed = dataSource.filter(item => {
            return (
                item.inputCloth &&
                item.flatType !== 'material' &&
                (item.clothType == null || item.clothType === '') &&
                item.skuId &&
                !checkedSkuRef2.current.includes(item.skuId)
            );
        });

        if (unprocessed.length === 0) return;

        const getClothType = async () => {
            for (const item of unprocessed) {
                if (!isMounted.current) break;

                checkedSkuRef2.current.push(item.skuId);

                if (!item.inputCloth) {
                    checkedSkuRef2.current = checkedSkuRef2.current.filter(
                        id => id !== item.skuId
                    );
                    continue;
                }

                try {
                    const clothRes = await API.getClothType({
                        imageUrl: item.inputCloth,
                    });

                    if (clothRes?.code === 0) {
                        const newType = clothRes.data;

                        setDataSource(prev =>
                            prev.map(it => {
                                if (it.skuId !== item.skuId) return it;
                                return {
                                    ...it,
                                    clothType: newType,
                                };
                            })
                        );

                        // 从checkedSkuRef2中移除对应的skuId
                        checkedSkuRef2.current = checkedSkuRef2.current.filter(id => id !== item.skuId);
                    }
                } catch (err) {
                    console.error('getClothType error', err);
                }
            }
        };

        getClothType();
    }, [projectType, dataSource, uploading]);

    useEffect(() => {
        if (dataSource.length === 0) return
        API.batchSaveSku([...dataSource]).then(res => {
            if (res?.code == 0) {

            } else {
                throw new Error(res.message)
            }
        }).catch(err => message.error(err.message))
    }, [dataSource])

    useEffect(() => {
        if (fileList.length > 0 && projectType) {
            handleUpload(fileList)
        }
    }, [fileList, projectType])


    // 首次批量上传
    function removeExtension(filename) {
        // 处理特殊文件名：'.' 和 '..'
        if (filename === '.' || filename === '..') return filename;
        const lastDot = filename.lastIndexOf('.');
        // 无后缀或隐藏文件（如 ".gitignore"）
        if (lastDot === -1 || lastDot === 0) return filename;

        return filename.substring(0, lastDot);
    }
    const handleUpload = async (fileList, targetSkuId) => {
        console.log('fileList', fileList)
        const smartPageUrlList = [] // 智能详情页成功上传的图
        let smartPageSkuName = ''
        const errorList = []
        const successList = []
        const currentSkuId = targetSkuId || uploadImgToSkuId
        setErrorList([...errorList])
        setSuccessList([...successList])

        // 再次编辑不可上传素材
        if (isEdit &&  projectType !== BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) return

        try {
            setUploading(true)
            // 详情页最多支持上传50张图
            if (projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
                if (fileList.length > uploadMaxNumber.current) {
                    message.info(`最多只能上传${uploadMaxNumber.current}张搭配图，将自动截取前${uploadMaxNumber.current}张`, 5)
                }
                fileList = [...fileList].slice(0, uploadMaxNumber.current)
            } else {
                fileList = [...fileList].slice(0, concurrentSku.current)
            }

            setUploadFileList(fileList)

            for (let file of fileList) {
                if (uploadAbort.current) { uploadAbort.current = false; break; }
                try {
                    if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
                        await Utils.validateImageFileToVideo(file, true) // 视频首帧图仅支持jpg、png
                    } else {
                        await Utils.validateImageFile(file, true)
                    }
                } catch (err) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                }
                if (uploadAbort.current) { uploadAbort.current = false; break; }

                // 详情页支持10K图，单张不超过40M
                let resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                

                if (!resizeRes || !resizeRes.success) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                } else file = resizeRes.file
                if (uploadAbort.current) { uploadAbort.current = false; break; }


                // 上传图片
                const res = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.BATCHIMAGES)
                if (!res || !res.isLegal) {
                    errorList.push(file)
                    setErrorList([...errorList])
                    continue
                }
                if (uploadAbort.current) { uploadAbort.current = false; break; }

                // 详情页、搭配上身需要将上传图保存到同一个sku
                if (projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
                    smartPageSkuName = removeExtension(file.name)
                    const url = res.data
                    smartPageUrlList.push({
                        url: url,
                        mainImage: true
                    })
                    successList.push({ url, name: smartPageSkuName })
                    setSuccessList([...successList])
                } else {
                    // 添加源素材到具体任务、保存单个sku
                    const url = res.data
                    const skuName = removeExtension(file.name)
                    API.batchSaveSku([{
                        projectId: projectId,
                        projectType: projectType,
                        skuName: skuName,
                        skuId: '',
                        inputImages: [{
                            url: url,
                            mainImage: true
                        }]
                    }]).then(res => {
                        if (res?.code == 0) {
                            listSkuByProject()
                            successList.push({ url, name: skuName })
                            setSuccessList([...successList])
                        } else if (res?.code == -5065) {
                            message.error(`上传已终止，每个项目最多上传${concurrentSku.current}件商品！`, 5000)
                            handleUploadAbort()
                        } else {
                            throw new Error(res.message)
                        }
                    }).catch(err => message.error(err.message))
                }
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            if (projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH && smartPageUrlList.length > 0) {

                const targetSku = dataSource.find(item => item.skuId === currentSkuId);

                if (currentSkuId) { // 智能详情页单独往对应sku中追加图
                    // 找到dataSource中uploadImgToSkuId对应的skuId项，将原本该项的inputImages追加到smartPageUrlList中
                    if (targetSku && targetSku.inputImages && Array.isArray(targetSku.inputImages)) {
                        smartPageUrlList.push(...targetSku.inputImages);
                    }
                }
                if (smartPageUrlList.length > uploadMaxNumber.current) { // 数量超出
                    smartPageUrlList.splice(uploadMaxNumber.current)
                    message.info(`最多只能上传${uploadMaxNumber.current}张搭配图，已自动截取前${uploadMaxNumber.current}张`, 5)
                }

                if (isEdit) { // 编辑时候不能直接save，要先存起来发起时候才会生效
                    console.log('smartPageUrlList', smartPageUrlList)
                    setDataSource(dataSource.map(item => {
                        if (item.skuId === currentSkuId) {
                            return {
                                ...item,
                                inputImages: smartPageUrlList
                            }
                        }
                        return item
                    }))
                } else {
                    API.batchSaveSku([{
                        ...targetSku,
                        projectId: projectId,
                        projectType: projectType,
                        skuName: targetSku?.skuName || smartPageSkuName,
                        skuId: currentSkuId ? currentSkuId : '',
                        inputImages: smartPageUrlList
                    }]).then(res => {
                        if (res?.code == 0) {
                            listSkuByProject()
                        } else if (res?.code == -5065) {
                            message.error(`上传已终止，每个项目最多上传${concurrentSku.current}件商品！`, 5000)
                            handleUploadAbort()
                        } else {
                            throw new Error(res.message)
                        }
                    }).catch(err => message.error(err.message))
                }
            }
            setFileList([])
            setErrorList([...errorList])
            setSuccessList([...successList])
            setUploading(false)
            setUploadImgToSkuId()
            // 全部图片上传失败
            setAllUploadFail(fileList.length == errorList.length)
            // 图片上传失败弹窗
            if (errorList.length > 0) setErrorOpen(true)
        }
    }

    // 上传图片
    const handleReupload = () => {
        setUploadOpen(true)
        setErrorOpen(false)
    }
    const handleCancel = () => {
        setErrorList([])
        setErrorOpen(false)
    }
    const handleGoBack = () => {
        if (dataSource.length === 0) {
            API.batchRemoveProject({
                projectIds: [projectId],
            }).then(res => {
                if (res?.code == 0) {
                    navigate("/home/product/batchImages")
                } else throw new Error(res.message)
            })
        } else {
            navigate("/home/product/batchImages")
        }
    }
    // 正在上传的图片
    const remainUploadLength = useMemo(() => {
        return successList.length + errorList.length
    }, [uploadFileList, successList, errorList])

    // 上传更多
    const [uploadOpen, setUploadOpen] = useState(false)
    const uploadDebounceRef = useRef(null)
    const handleAddMore = (file, fileList, skuId) => {
        if (uploadDebounceRef.current) {
            clearTimeout(uploadDebounceRef.current)
        }
        uploadDebounceRef.current = setTimeout(() => {
            handleUpload(fileList, skuId)
            setUploadOpen(false)
        }, 100)
    }
    // 停止上传
    const uploadAbort = useRef(false)
    const handleUploadAbort = () => {
        setFileList([])
        uploadAbort.current = true
    }

    // 智能详情页从我的项目中选图上传
    const tableRef = useRef(null)
    const handleMyProjectUpload = (urlList, callBack) => {
        const smartPageUrlList = []
        urlList.map(item => {
            smartPageUrlList.push({
                url: item.results?.[0].image,
                mainImage: true
            })
        })
        if (uploadImgToSkuId) { // 智能详情页单独往对应sku中追加图
            // 找到dataSource中uploadImgToSkuId对应的skuId项，将原本该项的inputImages追加到smartPageUrlList中
            const targetSku = dataSource.find(item => item.skuId === uploadImgToSkuId);
            if (targetSku && targetSku.inputImages && Array.isArray(targetSku.inputImages)) {
                smartPageUrlList.push(...targetSku.inputImages);
            }
        }

        if (smartPageUrlList.length > 50) {
            smartPageUrlList.splice(50)
            message.info(`最多只能上传50张详情图，已自动截取前50张`)
        }

        if (isEdit) { // 编辑时候不能直接save，要先存起来发起时候才会生效
            setDataSource(dataSource.map(item => {
                if (item.skuId === uploadImgToSkuId) {
                    return {
                        ...item,
                        inputImages: smartPageUrlList
                    }
                }
                return item
            }))
            tableRef.current.setUploadOpen(false)
            callBack(false)
            setUploadImgToSkuId()
        } else {
            API.batchSaveSku([{
                projectId: projectId,
                projectType: projectType,
                skuName: '未命名',
                skuId: uploadImgToSkuId ? uploadImgToSkuId : '',
                inputImages: smartPageUrlList
            }]).then(res2 => {
                if (res2?.code == 0) {
                    tableRef.current.setUploadOpen(false)
                    callBack(false)
                    listSkuByProject()
                    setUploadImgToSkuId()
                } else throw new Error(res2.message)

            }).catch(err => message.error(err.message))
        }
    }

    return (
        <>
            <div className={styles.ConfigPage}>
                <TableWrap
                    ref={tableRef}
                    dataSource={dataSource}
                    onMyProjectUpload={handleMyProjectUpload}
                    projectSerial={projectSerial}
                    isProCenter={isProCenter}
                    setDataSource={setDataSource}
                    listSkuByProject={listSkuByProject}
                    projectType={projectType}
                    projectId={projectId}
                    uploading={uploading}
                    projectName={projectName}
                    total={total}
                    isEdit={isEdit} // 是否是重新编辑
                    editSkuId={skuId} // 重新编辑时
                    editTaskId={taskId}  // 重新编辑时
                    handleAddMore={handleAddMore} />
                {
                    uploading && <div className={styles.uploadNumber}>
                        <p><span>{remainUploadLength} / {uploadFileList.length} 正在上传</span> <span onClick={handleUploadAbort}>停止</span></p>
                        <Progress percent={Math.ceil(remainUploadLength / uploadFileList.length * 100)} showInfo={false} />
                    </div>
                }
            </div>
            <PSAIModal
                open={errorOpen}
                title="以下图像不符合大小或格式要求，未能成功上传"
                okText={allUploadFail ? "重新上传" : "确定"}
                cancelText={allUploadFail ? "回到入口" : "继续上传"}
                maxWidth={520}
                onOk={allUploadFail ? handleReupload : handleCancel}
                onCancel={allUploadFail ? handleGoBack : handleReupload}
                onClose={() => setErrorOpen(false)}
            >
                {
                    <div className={styles.ErrorUploadNotice2}>
                        {
                            projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? (
                                <p>请上传不大于10M，分辨率不小于300*300px，长宽比介于 1:2.5~2.5:1 之间的JPG/PNG/WEBP图片</p>
                            ) : (
                                <p>
                                    请上传不大于30M，分辨率不小于500*500px，长宽比不超过2:1，
                                    JPG/PNG/WEBP图片
                                </p>
                            )
                        }
                        <ul className="_beauty_scrollbar">
                            {
                                errorList.map((item, index) => (
                                    <li key={index}>{item.name}</li>
                                ))
                            }
                        </ul>
                    </div>
                }
            </PSAIModal>
            <PSAIModal
                title="添加源素材"
                maxWidth={884}
                open={uploadOpen}
                footer={null}
                onCancel={() => setUploadOpen(false)}
            >
                <UploadBox
                    projectType={projectType}
                    onUpload={handleAddMore}
                    onMyProjectUpload={handleMyProjectUpload}
                />
            </PSAIModal>
        </>

    )
}

export default ConfigPage
